'use client';
import { ReactQueryDevtools as ReactQueryDevtools$1 } from './devtools.js';

const ReactQueryDevtools = process.env.NODE_ENV !== 'development' ? function () {
  return null;
} : ReactQueryDevtools$1;

// export const ReactQueryDevtoolsPanel: (typeof devtools)['ReactQueryDevtoolsPanel'] =
//   process.env.NODE_ENV !== 'development'
//     ? (function () {
//         return null
//       } as any)
//     : devtools.ReactQueryDevtoolsPanel

export { ReactQueryDevtools };
//# sourceMappingURL=index.js.map
